import { useEffect, useState } from "react";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({width: window.innerWidth, height: window.innerHeight});

  useEffect(() => {
    let resizeTimer;
    const handleWindowResize = () => {
      if (resizeTimer) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = setTimeout(function () {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }, 300);
    };
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return windowSize;
};

export default useWindowSize;